import { render } from "./View722.vue?vue&type=template&id=e636dec0&scoped=true"
import script from "./View722.vue?vue&type=script&lang=js"
export * from "./View722.vue?vue&type=script&lang=js"

import "./View722.vue?vue&type=style&index=0&id=e636dec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e636dec0"]])

export default __exports__